import { checkNullOrUndefined, formatter, resolveFobDisplay } from 'app/main/apps/common/AuraFunctions';

/**
 * PGSS-5673 — the FOB the order grid shows for a line, using the SAME rule as the Edit / View
 * Product dialog (`resolveFobDisplay`), so the two never disagree.
 *
 * The grid cell is bound to the line's `unit_cost`, which Order.js / ProductsTab.js seed with
 * `resolveFobCost` (the cost basis). That treats a FOB of 0 as "no FOB" and falls back to Unit Cost,
 * so a FOB the user cleared to 0 showed as the old Unit Cost in the grid (quote 29013Q: dialog 0,
 * grid 10). The seed itself stays as it is — convert-to-quote prices from it and the save sends it —
 * only what is DISPLAYED changes. The line's product carries the dialog's latest values (local
 * Update replaces it), so reading it here follows edits too.
 *
 * @param {object} orderDetail the line (with its nested `product`)
 * @param {*} lineValue the line's bound `unit_cost`, used when there is no product to read
 * @returns the FOB to display, or null when there is nothing to show
 */
export function orderLineFobDisplay(orderDetail, lineValue) {
  const product = orderDetail?.product;
  const value = product ? resolveFobDisplay(product) : lineValue;
  if (checkNullOrUndefined(value) || value === '') return null;
  const n = Number(value);
  return Number.isNaN(n) ? null : n;
}

/** The grid cell text: the FOB as currency, or empty when there is nothing to show. */
export function formatOrderLineFob(orderDetail, lineValue) {
  const fob = orderLineFobDisplay(orderDetail, lineValue);
  return fob === null ? '' : formatter.format(fob);
}

export default orderLineFobDisplay;
